import "core-js/modules/es.symbol";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.get-own-property-descriptors";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";
import "core-js/modules/web.dom-collections.for-each";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "regenerator-runtime/runtime";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import requester from "web/script/modules/requester";
import environment from "web/script/modules/environment";
var EXCLUDED_BRANDS = {
  "alexander-mcqueen": "Alexander McQueen",
  balenciaga: "Balenciaga",
  "bottega-veneta": "Bottega Veneta",
  celine: "Celine",
  fendi: "Fendi",
  gucci: "Gucci",
  "louis-vuitton": "Louis Vuitton",
  moncler: "Moncler",
  moynat: "Moynat",
  "patou-designer": "Patou",
  rimowa: "Rimowa",
  "saint-laurent": "Saint Laurent",
  valentino: "Valentino"
};
export function excludedBrandNames() {
  var brandNames = Object.keys(EXCLUDED_BRANDS).map(function (key) {
    return EXCLUDED_BRANDS[key];
  });
  return brandNames;
}
export function isExcludedDesignerOnPage() {
  var designerSlug = environment.get("analyticsProduct.designer_slug");
  return designerSlug in EXCLUDED_BRANDS;
}
export function getRewardDetails(_x) {
  return _getRewardDetails.apply(this, arguments);
}

function _getRewardDetails() {
  _getRewardDetails = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(webToken) {
    var defaultReward, jsonData;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // TODO: Make error state more user friendly
            defaultReward = {
              reward: "%",
              date_range: "-"
            };

            if (!(webToken == null)) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return", defaultReward);

          case 3:
            jsonData = _objectSpread({}, defaultReward);
            _context.prev = 4;
            _context.next = 7;
            return requester.get("/financial-incentive/", {
              token: webToken
            });

          case 7:
            jsonData = _context.sent;
            _context.next = 14;
            break;

          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](4);
            console.error(_context.t0); // Couldn't get reward data - return default

            return _context.abrupt("return", defaultReward);

          case 14:
            return _context.abrupt("return", jsonData);

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[4, 10]]);
  }));
  return _getRewardDetails.apply(this, arguments);
}

export default getRewardDetails;